/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The PdfPreviewUrlVo model module.
   * @module textbook/model/PdfPreviewUrlVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PdfPreviewUrlVo</code>.
   * @alias module:textbook/model/PdfPreviewUrlVo
   * @class
   * @param previewUrl {String} 带签名的PDF预览URL（包含OSS文档处理参数） 示例：https://bucket.oss-cn-hangzhou.aliyuncs.com/file.pdf?Expires=xxx&OSSAccessKeyId=xxx&Signature=xxx&x-oss-process=doc/preview,print_0,copy_0,export_0,maxpage_9999/watermark,size_40,t_100,rotate_0,color_%23FFFFFF,text_xxx 
   * @param expireTime {Date} URL过期时间（ISO 8601格式）
   * @param expireSeconds {Integer} URL有效期（秒），默认3600（1小时）
   */
  var exports = function(previewUrl, expireTime, expireSeconds) {
    var _this = this;

    _this['previewUrl'] = previewUrl;
    _this['expireTime'] = expireTime;
    _this['expireSeconds'] = expireSeconds;
  };

  /**
   * Constructs a <code>PdfPreviewUrlVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/PdfPreviewUrlVo} obj Optional instance to populate.
   * @return {module:textbook/model/PdfPreviewUrlVo} The populated <code>PdfPreviewUrlVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'previewUrl')) {
        obj['previewUrl'] = ApiClient.convertToType(data['previewUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'expireTime')) {
        obj['expireTime'] = ApiClient.convertToType(data['expireTime'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'expireSeconds')) {
        obj['expireSeconds'] = ApiClient.convertToType(data['expireSeconds'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 带签名的PDF预览URL（包含OSS文档处理参数） 示例：https://bucket.oss-cn-hangzhou.aliyuncs.com/file.pdf?Expires=xxx&OSSAccessKeyId=xxx&Signature=xxx&x-oss-process=doc/preview,print_0,copy_0,export_0,maxpage_9999/watermark,size_40,t_100,rotate_0,color_%23FFFFFF,text_xxx 
   * @member {String} previewUrl
   */
  exports.prototype['previewUrl'] = undefined;
  /**
   * URL过期时间（ISO 8601格式）
   * @member {Date} expireTime
   */
  exports.prototype['expireTime'] = undefined;
  /**
   * URL有效期（秒），默认3600（1小时）
   * @member {Integer} expireSeconds
   */
  exports.prototype['expireSeconds'] = undefined;



  export default exports;
;


